// Utils

import { urlTools } from '../../utils/tools/urlTools';

// Constants

import { ENDPOINTS_NAMES } from '../common/endpointsNames';
import customEndpoints from './customEndpoints';
import environments from './environments';
import mode from './mode';

const {
    ACCESS_CODE_REDIRECT,
    ACCOUNT_ACCESS_CODE,
    ACCOUNT_LOGIN,
    ACCOUNT_SIGNUP,
    ADDITIONAL_INFO,
    ADD_CONSUMER,
    ADD_CONSUMER_WITHOUT_CALL_ID,
    ADD_MEMBER,
    AGENT_LEFT_NAV_PARAMS,
    AGENT_LIST,
    AGENTS_SEARCH_BY_NAME,
    AGENTS_SEARCH_BY_ZIP,
    ANNOUNCEMENTS,
    APPLICATIONS,
    APPLICATIONS_NEW,
    ARCHIVE_HH_ARCHIVE,
    ARCHIVE_HH_SEARCH,
    ARCHIVE_HH_UNARCHIVE,
    SSIO_EXECUTE_STEP,
    SSIO_TEST_PLAN_RESULTS,
    SSIO_TEST_PLAN_DETAILS,
    SSIO_RESTART_STEP,
    ASSISTER_VIEW_PROFILE,
    ASSISTER_IND,
    AUTHENTICATION_SUCCESS_REDIRECT,
    BACK_TO_DASHBOARD,
    BLOOD_RELATIONSHIPS_CHECK,
    BLOOD_RELATIONSHIPS_ENDPOINT,
    BLOOD_RELATIONSHIPS_ENDPOINT_WHOLE_LIST,
    BROKER_ADD_NEW_INDIVIDUAL,
    BROKER_EMP,
    BROKER_IND,
    BROKER_NEW_EMP,
    BROKER_TICKET,
    BROKER_VIEW_PENDING_INDIVIDUAL,
    BROKER_VIEW_PROFILE,
    BROKERCONNECT_DATA,
    BROKERCONNECT_PARTICIPATION_DETAILS,
    BROKERCONNECT_HOURS,
    BROKERCONNECT_AVAILABILITY,
    CANCEL_APP,
    COPY_APP_BY_CASE_NUMBER,
    CLONE_APP_BY_CASE_NUMBER,
    CLONE_APP_BY_SSAP_ID,
    CHANGE_LANGUAGE,
    CHANGE_APP_STATUS,
    CHECK_ACTIVE_ENROLLMENT,
    CHECK_FOR_PENDING_APPLICATION,
    COMMENTS,
    COMMUNICATION_PREFERENCES,
    OTP_VERIFY,
    OTP_SEND,
    PARTIAL_UPDATE,
    TELEX_ENVIRONMENT,
    COUNTIES_FOR_STATE_ENDPOINT,
    COUNTIES_FOR_STATES_ENDPOINT,
    COUNTY_ENDPOINT,
    COUNTRIES_ENDPOINT,
    CUSTOM_GROUPING,
    CUSTOM_GROUPING_DETAIL,
    DASHBOARD_ENDPOINT,
    DASHBOARD_MODELS,
    DASHBOARD_MODELS_LITE,
    DOCUMENTS_VERIFICATION_DATA,
    DOCUMENTS_VERIFICATION_ENDPOINT,
    DELEGATION_HISTORY,
    EDE_ID_PROOFING_ENDPOINT,
    EDE_SEARCH_ENDPOINT,
    EDE_SEARCH_ADD_TO_BOB,
    EDE_ADD_CONSUMER,
    EDE_BACK_TO_ACTIVE_INDIVIDUALS,
    EDE_BACK_TO_DASHBOARD,
    ELIGIBILITY_RESULTS,
    ELIGIBILITY_RESULTS_NEW,
    EMAIL_PDF_PREVIEW,
    EMAIL_PDF_PREVIEW_WITH_IMPERSONATION,
    ENLARGED_FONT_ENABLED,
    MEMBER_ENROLLMENT_LIST_DETAILS,
    MEMBER_ENROLLMENT_LIST_ENROLLEE_DETAILS,
    MEMBER_ENROLLMENT_DETAILS,
    MEMBER_ENROLLMENT_LIST_PERMISSIONS,
    MEMBER_ENROLLMENT_LIST_ENROLLMENT_DETAIL_SNAPSHOT,
    MEMBER_ENROLLMENT_LIST_ENROLLMENT_RESEND_COMMENT,
    MEMBER_ENROLLMENT_LIST_ENROLLMENT_REINSTATE_STATUS,
    MEMBER_ENROLLMENT_LIST_ENROLLMENT_UPDATE_STATUS,
    MEMBER_ENROLLMENT_LIST_ENROLLMENT_CANCEL_ACTIVE,
    MEMBER_ENROLLMENT_LIST_ENVIRONMENT_CANCEL_PREMIUM_HISTORY,
    MEMBER_ENROLLMENT_LIST_ENROLLMENT_UPDATE_ENROLLMENT,
    ENVIRONMENT_VARIABLES,
    EXTERNAL_CONTENT,
    FLOW_ENDPOINT,
    GET_SSN_DETAILS,
    GA_CARRIER_GAEP_LIST,
    GET_ENROLLMENT_HISTORY,
    GET_EXISTING_APP_ID,
    GET_IVR_DATA,
    GET_SCREENPOP_COUNTIES,
    GET_UNREAD_NOTIFICATION_COUNT,
    HTML_2_PDF_SCRIPT_ENDPOINT,
    HEADER_ROLES_LINK,
    IDA_LINK,
    IMAGES,
    INBOX_HOME,
    INDPORTAL_ERROR,
    INITIAL_DATA_ENDPOINT,
    IVM_DOWNLOAD_DOCUMENT,
    IVM_CONFIRMATION,
    IVM_ENVIRONMENT,
    IVM_ISSUER_LIST,
    IVM_PREVIEW_PACKET,
    IVM_PREVIEW_STATEMENT,
    IVM_RESEND_PACKETS,
    IVM_REVIEW_PACKET,
    IVM_SEND_PACKET,
    IVM_STATEMENT_PACKETS,
    IVM_UPDATE_EMAIL_PHONE,
    IVM_UPDATE_COMMENTS,
    FETCH_HOUSHOLDS_ELIGIBILITY,
    LOG_CALL_DATA,
    LOGOUT_URL,
    J_SECURITY_CHECK,
    LCE_REFERRAL,
    LCE_CLONE,
    MEMBER_AFFORDABILITY,
    MEMBER_ACCOUNT_ACTIVITY_DETAILS,
    MEMBER_ACCOUNT_ACTIVITY_EVENT_COMMENTS,
    MEMBER_ACCOUNT_ACTIVITY_LOG_CALL,
    MEMBER_ACCOUNT_ACTIVITY_ADD_CALL_NOTE,
    MEMBER_ACCOUNT_ACTIVITY_ADD_CHAT_NOTE,
    MEMBER_ACCOUNT_ACTIVITY_EXPORT_HISTORY,
    MEMBER_ACCOUNT_ACTIVITY_INIT_CALL,
    MULTIHOUSEHOLD_DETAILS,
    NAV_BAR,
    NEW_INBOX_HOME,
    NOTIFICATIONS,
    OLD_START_SSAP_BY_CASE_NUMBER,
    OVERRIDE_DOCUMENTS,
    PAY_FOR_HEALTH,
    CHANGE_TERMINATION_DATE,
    DISENROLL_MEMBERS,
    PARTNER_LIST,
    PRE_ELIGIBILITY,
    PRE_ELIGIBILITY_DISCLAIMER_FROM_HOME,
    PRE_ELIGIBILITY_DISCLAIMER_FROM_FLOW,
    PRE_ELIGIBILITY_DISCLAIMER,
    PRE_ELIGIBILITY_DISCLAIMER_JSP,
    PRE_ELIGIBILITY_SCREENING,
    PRE_ELIGIBILITY_RESULTS,
    PRE_ELIGIBILITY_RESULTS_APTC_IMAGE,
    PRE_ELIGIBILITY_RESULTS_CSR_IMAGE,
    PRE_ELIGIBILITY_RESULTS_CHIP_IMAGE,
    PRE_ELIGIBILITY_RESULTS_INELIGIBLE_IMAGE,
    PRE_ELIGIBILITY_RESULTS_MEDICARE_IMAGE,
    PRE_ELIGIBILITY_RESULTS_MEDICAID_IMAGE,
    PRE_ELIGIBILITY_RESULTS_NA_IMAGE,
    PRE_ELIGIBILITY_RESULTS_STATE_SUBSIDY_IMAGE,
    PRE_ELIGIBILITY_RESULTS_ZERO_APTC_IMAGE,
    PRE_ELIGIBILITY_BROWSE_PLANS,
    PRE_ELIGIBILITY_BROWSE_PLANS_REDIRECT,
    PRE_ELIGIBILITY_CALCULATE_SAVINGS,
    PRE_ELIGIBILITY_RESULTS_NAVIGATE_NEXT,
    POST_TICKET,
    PLAN_SUMMARY,
    PLAN_SHOPPING,
    QEP,
    REMOVE_UPLOADED_DOCUMENT,
    REPORT_A_CHANGE,
    REQUEST_FULL_DETERMINATION,
    REVIEW_SUMMARY_PDF_DOWNLOAD,
    RIDP_CURRENT_USER_INFO_ENDPOINT,
    RIDP_VIEWREF_ENDPOINT,
    RIDP_VALIDATE_PRIMARY_ENDPOINT,
    RIDP_VALIDATE_SECONDARY_ENDPOINT,
    RIDP_MANUAL_VERIFICATION_ENDPOINT,
    RIDP_VALIDATE_FARS_ENDPOINT,
    RIDP_CLEAR_DHS_ENDPOINT,
    SSAP_PRE_ELIGIBILITY,
    SAVE_COMMENT,
    SAVE_CUSTOM_GROUPING,
    SAVE_DATA_ENDPOINT,
    SAVE_TOBACCO,
    SAVE_SEEKS_QHP_CHANGES,
    SCREENPOP_ASSISTER_DATA,
    SCREENPOP_BROKER_DATA,
    SEARCH_APPLICANT,
    SECURE_INBOX_SEND,
    SET_ACTIVE_HOUSEHOLD,
    SET_FULL_DETERMINATION,
    START_SHOPPING,
    START_SSAP_BY_CASE_NUMBER,
    START_SSAP_BY_YEAR,
    SUBMIT_DOCUMENTS,
    TERMINATE_PLAN,
    TERMINATE_DENTAL_PLAN,
    TERMINATE_HEALTH_PLAN,
    TICKET_DETAIL,
    TICKETS,
    TICKET_TYPES,
    TICKET_MGMT_CATEGORIES,
    TICKET_MGMT_PERMISSIONS,
    TICKET_MGMT_UPDATE_CATEGORY,
    TICKET_MGMT_SAVE_NEW_TICKET_TYPE,
    TICKET_MGMT_WORKGROUPS,
    TICKET_MGMT_WORKFLOW_BY_CATEGORY,
    TICKET_MGMT_WORKFLOW_TYPES,
    TICKET_MGMT_CREATE_PAGE,
    TICKET_MGMT_LIST,
    TICKET_MGMT_DEFAULT_QUEUE,
    TICKET_MGMT_MANAGE_QUEUE,
    TICKET_MGMT_GET_CONSUMER_DATA,
    TICKET_MGMT_TICKET_DETAIL,
    TICKET_MGMT_TICKET_DETAIL_BACKDOOR,
    TICKET_MGMT_TICKET_HISTORY,
    TICKET_MGMT_TICKET_COMMENTS,
    TICKET_MGMT_TICKET_DOCUMENTS,
    TICKET_MGMT_TICKET_TASKLIST,
    TICKET_MGMT_TICKET_SEND_MESSAGE,
    TICKET_MGMT_REASSIGN_TICKET,
    TICKET_MGMT_GET_ACTIVE_TASKS,
    TICKET_MGMT_GET_ALL_USERS_FOR_QUEUE,
    TICKET_MGMT_GET_FILE_UPLOAD_FLAG,
    TICKET_MGMT_GET_RECLASSIFIED_PROPERTIES,
    TICKET_MGMT_GET_TAGS,
    TICKET_MGMT_UPDATE_TAG,
    TICKET_MGMT_WORKGROUPS_TAGS,
    TICKET_MGMT_EXCHANGE_ASSIGNEES,
    TICKET_MGMT_UPDATE_ASSIGNEE_ATTRIBUTES,
    TICKET_MGMT_GET_TICKET_TYPES,
    TICKET_MGMT_SUBMIT_RECLASSIFY,
    TICKET_MGMT_CANCEL_TICKET,
    TICKET_MGMT_REOPEN_TICKET,
    TICKET_MGMT_USER_TASKLIST,
    TICKET_MGMT_COMPLETE_TASK,
    TICKET_MGMT_UPLOAD_ATTACHMENTS,
    TICKET_MGMT_SAVE_COMMENT,
    TOBACCO_EXEMPT_GET_APPLICANTS,
    TOBACCO_EXEMPT_SAVE_ADDINFO,
    GET_CUSTOM_FIELDS_URL,
    GET_CUSTOM_FIELDS_FOR_DEV_ENVIRONMENT,
    GET_USER_SECURITY_DETAILS,
    RESET_PASSWORD,
    RESET_PASSWORD_ALTERNATE_EMAIL,
    UNLOCK_USER,
    TRIBES_ENDPOINT,
    UNREAD_MESSAGE_COUNT,
    UPLOAD_VERIFICATION_DOCUMENT,
    VALIDATE_ADDRESS_ENDPOINT,
    VALIDATE_ZIP,
    VERIFICATION_PENDING,
    VERIFICATION_RESULT_DASHBOARD,
    VERIFY_ACCESS_CODE,
    VIEW_MEMBER,
    WRONG_ENDPOINT,
    VIEW_MEMBER_ACCOUNT,
    ZIPCODE_COUNTIES,
    SEARCH_CEC,
    CEC_EXPORT_BOB,
    CEC_EXPORT_BOB_NON_CA,
    ENTITY_SITE_LIST,
    FILTER_CEC_ENTITYADMIN,
    REASSIGN_BOB_TO_CEC,
    ENTITY_ASSISTERS_LIST,
    ACK_TRNFR_STATUS,
    GET_TRNFR_STATUS,
    PARTNER_BROKER,
    PRE_OEP_LANDING,
    WORKGROUP_BY_STATUS,
    WORKGROUP_BY_DUEDATE,
    WORKGROUP_BY_USER,
    GET_ATTACHMENTS_URL,
    POST_ATTACHMENTS_URL,
    DELETE_ATTACHMENT_URL,
    VIEW_ATTACHMENT_URL,
    RESOLVED_DATE_REPORTS_BY_WORKGROUP,
    RESOLVED_DATE_REPORTS_BY_WORKGROUP_ASSIGNEE,
    RESOLVED_DATE_REPORTS_BY_WORKGROUP_ASSIGNEE_DRILL_DOWN,
    RESOLVED_DATE_REPORTS_GROUP_BY_ASSIGNEE_FOR_ASSIGNEEID_DRILL_DOWN,
    UPLOADED_DOCUMENT_URL,
    MEMBER_APP_LIST_CONTROLLER,
    MEMBER_APP_LIST_OUTBOUND_BUTTON_STATUS,
    MEMBER_APP_LIST_GET_APPS,
    MEMBER_APP_LIST_OVERRIDE_COMMENT,
    MEMBER_APP_LIST_INIT_VERIFICATIONS,
    MEMBER_APP_LIST_RERUN_ELIGIBILITY,
    MEMBER_APP_LIST_TERMINATE_PLAN,
    MEMBER_APP_LIST_REVERSE_DENIAL,
    MEMBER_APP_LIST_UPDATE_CARRIER,
    MEMBER_APP_LIST_SAVE_SEP_DETAILS,
    MEMBER_APP_LIST_SAVE_SEP_OVERRIDE_DETAILS,
    MEMBER_APP_LIST_SEND_OBAT,
    MEMBER_APP_LIST_UPDATE_ENROLLMENT_STATUS,
    MEMBER_APP_LIST_OVERRIDE_APPLICATION_END_SEP,
    MEMBER_APP_LIST_CHECK_ACTIVE,
    MEMBER_APP_LIST_PROGRAM_ELIGIBILITY,
    MEMBER_APP_LIST_OVERRIDE_PROGRAM_ELIGIBILITY,
    MEMBER_APP_LIST_ADD_OVERRIDE_COMMENT,
    MEMBER_APP_LIST_SEP_EVENT_DETAILS,
    MEMBER_APP_LIST_GET_SEP_DETAILS,
    MEMBER_APP_LIST_OVERRIDE_APPLICATION_LOCK,
    MEMBER_APP_LIST_GET_ELIGIBILITY_DATE_DETAILS,
    MEMBER_APP_LIST_GET_SEP_PERIOD_DATES,
    MEMBER_APP_LIST_GET_SEP_EVENTS_BY_APPLICATION_TYPE,
    MEMBER_APP_LIST_GET_QHP_APPLICANTS,
    MEMBER_APP_LIST_SAVE_SHOPPING_WINDOW,
    MEMBER_APP_LIST_NEW_SSAP_START,
    MEMBER_APP_LIST_APPLICATIONS,
    MEMBER_APP_LIST_CLONE_APPLICATION_BY_CASENUMBER,
    DMI_GET_DMI_VERIFICATIONS,
    DMI_VLP_VERIFICATIONS,
    DMI_GET_HOUSEHOLD_INCOME,
    DMI_UPLOAD_DOCUMENT_ENDPOINT,
    DMI_UPLOAD_DOCUMENT_QR_CODE_ENDPOINT,
    DMI_DELETE_UPLOADED_DOCUMENT_ENDPOINT,
    DMI_OVERRIDE_DOCUMENTS,
    DMI_LOAD_DOCUMENT_ENDPOINT,
    DMI_VIEW_UPLOADED_DOCUMENT_ENDPOINT,
    DMI_VIEW_TICKET_ENDPOINT,
} = ENDPOINTS_NAMES;

const endpointsValues = {
    [ENVIRONMENT_VARIABLES]: '/ui/environment',
    [PRE_OEP_LANDING]: '/open_enrollment_has_not_started_yet',
    [PRE_ELIGIBILITY_DISCLAIMER_FROM_HOME]: '/preeligibility/disclaimer#/?fromHome=1',
    [PRE_ELIGIBILITY_DISCLAIMER_FROM_FLOW]: '/preeligibility/disclaimer#/?fromFlow=1',
    [PRE_ELIGIBILITY_DISCLAIMER]: '/preeligibility/disclaimer',
    [PRE_ELIGIBILITY_DISCLAIMER_JSP]: '/',
    [PRE_ELIGIBILITY_SCREENING]: '/preeligibility/preeligibilityecreening',
    [PRE_ELIGIBILITY_RESULTS]: '/preeligibility/results',
    [PRE_ELIGIBILITY]: '/preeligibility',
    [PRE_ELIGIBILITY_BROWSE_PLANS]: '/iex/browseplans',
    [PRE_ELIGIBILITY_BROWSE_PLANS_REDIRECT]: '/private/saveIndividualPHIX',
    [PRE_ELIGIBILITY_CALCULATE_SAVINGS]: '/calculateSavings',
    [PRE_ELIGIBILITY_RESULTS_NAVIGATE_NEXT]:
        '/iex/updateStageInEligLeadRecord?coverageYear=${coverageYear}&coverageYear=${coverageYear}',
    [PRE_ELIGIBILITY_RESULTS_APTC_IMAGE]: '/resources/images/${statecode}/money.png',
    [PRE_ELIGIBILITY_RESULTS_CSR_IMAGE]: '/resources/images/${statecode}/chart.png',
    [PRE_ELIGIBILITY_RESULTS_CHIP_IMAGE]: '/resources/images/${statecode}/children.png',
    [PRE_ELIGIBILITY_RESULTS_INELIGIBLE_IMAGE]: '/resources/images/${statecode}/shield.png',
    [PRE_ELIGIBILITY_RESULTS_MEDICARE_IMAGE]: '/resources/images/${statecode}/grandparents.png',
    [PRE_ELIGIBILITY_RESULTS_MEDICAID_IMAGE]: '/resources/images/${statecode}/family.png',
    [PRE_ELIGIBILITY_RESULTS_NA_IMAGE]: '/resources/images/${statecode}/shield.png',
    [PRE_ELIGIBILITY_RESULTS_STATE_SUBSIDY_IMAGE]: '/resources/images/${statecode}/courthouse.png',
    [PRE_ELIGIBILITY_RESULTS_ZERO_APTC_IMAGE]: '/resources/images/${statecode}/shield.png',
    [PLAN_SUMMARY]: '/indportal/ajs#/plansummary',
    [APPLICATIONS]: '/indportal#/applications',
    [APPLICATIONS_NEW]: '/mp/getMyApplications?coverageYear=${coverageYear}',
    [COMMUNICATION_PREFERENCES]: '/indportal/communicationPreferences',
    [OTP_VERIFY]: '/indportal/otp/verify',
    [OTP_SEND]: '/indportal/otp/send',
    [PARTIAL_UPDATE]: '/indportal/partialUpdate',
    [TELEX_ENVIRONMENT]: '/ms-telex/api/environment',
    [COPY_APP_BY_CASE_NUMBER]: '/indportal/copyApplicationByCaseNumber/${caseNumber}',
    [INDPORTAL_ERROR]: '/indportal#/error',
    [ADDITIONAL_INFO]: '/mp/additionalinfo',
    [CUSTOM_GROUPING]: '/indportal#/customGrouping',
    [QEP]: '/indportal#/qephome',
    [TOBACCO_EXEMPT_GET_APPLICANTS]: '/indportal/getApplicantsForAddInfo?coverageYear=',
    [TOBACCO_EXEMPT_SAVE_ADDINFO]: '/indportal/saveAdditionalInfo?coverageYear=',
    [ELIGIBILITY_RESULTS]: '/indportal#/eligibilityresults?caseNumber=${caseNumber}',
    [REQUEST_FULL_DETERMINATION]: '/indportal/requestFullDetermination',
    [DASHBOARD_MODELS]: '/indportal/getDashboardModels?userId=1&apiVersion=2',
    [DASHBOARD_MODELS_LITE]: '/indportal/dashboardModelsLite',
    [MULTIHOUSEHOLD_DETAILS]: '/indportal/multiHouseholdDetails',
    [SAVE_TOBACCO]: '/indportal/saveTobaccoChanges',
    [SET_ACTIVE_HOUSEHOLD]: '/indportal/activeHousehold',
    [SAVE_SEEKS_QHP_CHANGES]: '/indportal/saveSeeksQHPChanges',
    [ELIGIBILITY_RESULTS_NEW]: '/indportal/getApplicationDetails?caseNumber=${encryptedCaseNumber}',
    [SET_FULL_DETERMINATION]: '/indportal/setFullDetermination',

    //[TICKETS]:                                 '/ticketmgmt/ticket/customerTickets',
    [TICKETS]: '/ticketmgmt/ticket/customerTickets/${id}',
    [TICKET_MGMT_CATEGORIES]: '/ticketmgmt/ticket/categories',
    [TICKET_MGMT_WORKGROUPS]: '/ticketmgmt/ticket/workgroups',
    [TICKET_MGMT_WORKFLOW_BY_CATEGORY]: '/ticketmgmt/ticket/categories/${categoryName}/workflows',
    [TICKET_MGMT_WORKFLOW_TYPES]: '/ticketmgmt/ticket/workflowTypes',
    [TICKET_MGMT_PERMISSIONS]: '/ticketmgmt/ticket/validPermissionNames',
    [TICKET_MGMT_UPDATE_CATEGORY]: '/ticketmgmt/ticket/updateTkmCategory',
    [TICKET_MGMT_CREATE_PAGE]: '/ticketmgmt/ticket/createpage',
    [TICKET_MGMT_SAVE_NEW_TICKET_TYPE]: '/ticketmgmt/ticket/saveNewTicketType',
    [TICKET_MGMT_LIST]: '/ticketmgmt/ticket/ticketlist?resetflag=true',
    [TICKET_MGMT_DEFAULT_QUEUE]: '/ticketmgmt/ticket/defaultqueue',
    [TICKET_MGMT_MANAGE_QUEUE]: '/ticketmgmt/ticket/managequeue',
    [TICKET_MGMT_GET_TAGS]: '/tag/all',
    [TICKET_MGMT_UPDATE_TAG]: '/tag',
    [TICKET_MGMT_WORKGROUPS_TAGS]: '/tag/workgroups-tags-list',
    [TICKET_MGMT_EXCHANGE_ASSIGNEES]: '/tag/workgroups-tags/search?${params}',
    [TICKET_MGMT_UPDATE_ASSIGNEE_ATTRIBUTES]: '/tag/workgroups-tags',
    [TICKET_MGMT_UPDATE_ASSIGNEE_ATTRIBUTES]: '/tag/workgroups-tags',

    // QlE
    [VERIFICATION_RESULT_DASHBOARD]: '/ssap/verificationResultDashboard?caseNumber=${caseNumber}&lang=${language}',
    [DOCUMENTS_VERIFICATION_DATA]: '/qleVerification/fetchEventDetails/${caseNumber}',
    [DOCUMENTS_VERIFICATION_ENDPOINT]: '/qle/documents?caseNumber=${caseNumber}',
    [OVERRIDE_DOCUMENTS]: '/qleVerification/overrideDocuments',
    [REMOVE_UPLOADED_DOCUMENT]: '/qleVerification/removeDocument',
    [SUBMIT_DOCUMENTS]: '/qleVerification/submitDocument',
    [UPLOAD_VERIFICATION_DOCUMENT]: '/qleVerification/uploadDocument',
    [UPLOADED_DOCUMENT_URL]: '/indportal/viewDocument?documentId=${encryptedDocumentPath}',

    [TICKET_MGMT_GET_CONSUMER_DATA]: '/ticketmgmt/ticket/sendSecureMsg',
    [TICKET_MGMT_TICKET_DETAIL]: '/ticketmgmt/ticket/ticketdetail/${encTicketId}',
    [TICKET_MGMT_TICKET_DETAIL_BACKDOOR]: '/indportal/switchCSRToTicket/${encTicketId}',
    [TICKET_MGMT_TICKET_HISTORY]: '/ticketmgmt/ticket/tickethistory/${encTicketId}',
    [TICKET_MGMT_TICKET_COMMENTS]: '/ticketmgmt/ticket/showcomments/${encTicketId}',
    [TICKET_MGMT_TICKET_DOCUMENTS]: '/ticketmgmt/ticket/getTicketDocuments/${encTicketId}',
    [TICKET_MGMT_TICKET_TASKLIST]: '/ticketmgmt/ticket/getticketTaskList/${encTicketId}',
    [TICKET_MGMT_TICKET_SEND_MESSAGE]: '/ticketManagement/ticket/ticketdetail/${encTicketId}/sendMessage',
    [TICKET_MGMT_REASSIGN_TICKET]:
        '/ticketmgmt/ticket/reassignTicket?taskId=${taskId}&queueName=${queueName}&ticketId=${ticketId}&assignee=${assignee}&action=${action}',
    [TICKET_MGMT_GET_ACTIVE_TASKS]: '/ticketmgmt/ticket/getTicketActiveTasks?ticketId=${ticketId}',
    [TICKET_MGMT_GET_ALL_USERS_FOR_QUEUE]: '/ticketmgmt/ticket/getAllUsersForQueue?qName=${qName}',
    [TICKET_MGMT_GET_FILE_UPLOAD_FLAG]: '/ticketmgmt/ticket/fileUploadFlag/${category}/${type}',
    [TICKET_MGMT_GET_RECLASSIFIED_PROPERTIES]: '/ticketmgmt/ticket/fetchReclassfiedTargetProperties',
    [TICKET_MGMT_GET_TICKET_TYPES]: '/ticketmgmt/ticket/fetchTicketTypes',
    [TICKET_MGMT_SUBMIT_RECLASSIFY]: '/ticketmgmt/ticket/submitTicketReclassifyAction',
    [TICKET_MGMT_CANCEL_TICKET]: '/ticketmgmt/ticket/cancelticket',
    [TICKET_MGMT_REOPEN_TICKET]: '/ticketmgmt/ticket/reopen',
    [TICKET_MGMT_USER_TASKLIST]: '/ticketmgmt/ticket/userTickettasklist',
    [TICKET_MGMT_COMPLETE_TASK]: '/ticketmgmt/ticket/completeUserTask',
    [TICKET_MGMT_UPLOAD_ATTACHMENTS]: '/ticketmgmt/ticket/uploadTicketAttachments',
    [TICKET_MGMT_SAVE_COMMENT]: '/ticketmgmt/ticket/savecomment',
    [GET_CUSTOM_FIELDS_URL]: '/tickets/customfield',
    [GET_CUSTOM_FIELDS_FOR_DEV_ENVIRONMENT]: '/mocks/custom-fields.json',
    [GET_USER_SECURITY_DETAILS]: '/account/questions',
    [RESET_PASSWORD]: '/crm/consumer/sendresetpasswordemail',
    [RESET_PASSWORD_ALTERNATE_EMAIL]: '/crm/consumer/sendresetpasswordalternateemail',
    [UNLOCK_USER]: '/crm/consumer/unlockaccount',

    [POST_TICKET]: '/brokerconsumerticket',
    [COMMENTS]: '/tickets/${id}/comments',
    [SAVE_COMMENT]: '/tickets/${id}/comments',
    [TICKET_DETAIL]: '/tickets/${id}',
    [TICKET_TYPES]: '/tickets/types/${id}',

    [BLOOD_RELATIONSHIPS_CHECK]: '/newssap/validateRelationships',
    [BLOOD_RELATIONSHIPS_ENDPOINT]: '/newssap/relationships',
    [BLOOD_RELATIONSHIPS_ENDPOINT_WHOLE_LIST]: '/newssap/commonRelationships',
    [TRIBES_ENDPOINT]: '/newssap/stateswithtribes',
    [COUNTY_ENDPOINT]: '/newssap/countiesforstate/',
    [COUNTIES_FOR_STATE_ENDPOINT]: '/newssap/countiesforstate/${state}/${postalCode}',
    [COUNTIES_FOR_STATES_ENDPOINT]: '/newssap/countiesforstates/',
    [FLOW_ENDPOINT]: '/newssap/configuration',
    [INITIAL_DATA_ENDPOINT]: '/newssap/application/${caseNumber}',
    [MEMBER_AFFORDABILITY]: '/newssap/configuration/affordability/${coverageYear}',
    [SSAP_PRE_ELIGIBILITY]: '/newssap/preeligibility/',
    [SAVE_DATA_ENDPOINT]: '/newssap/save',
    [CANCEL_APP]: '/newssap/cancel',
    [START_SSAP_BY_CASE_NUMBER]: '/newssap/start?caseNumber=${caseNumber}',
    [START_SSAP_BY_YEAR]: '/newssap/start?coverageYear=${applicationYear}',
    [WRONG_ENDPOINT]: '/newssap/fghsjjsj', // For testing only

    [CHECK_ACTIVE_ENROLLMENT]: '/ssap/checkActiveEnrollment?caseNumber=${caseNumber}',
    [CLONE_APP_BY_CASE_NUMBER]: '/ssap/clone?caseNumber=${caseNumber}',
    [CLONE_APP_BY_SSAP_ID]: '/ssap/clone?encryptedApplicationId=${encryptedApplicationId}&consumer=portal_ui',
    [VERIFICATION_PENDING]: '/ssap/pendingVerification',
    [OLD_START_SSAP_BY_CASE_NUMBER]: '/ssap?caseNumber=${caseNumber}',
    [CHANGE_APP_STATUS]: '/ssap/changeAppStatusOfSubmittedAndSigned/${caseNumber}',
    [GET_EXISTING_APP_ID]: '/ssap/getExistingApplicationCloneId',

    [REVIEW_SUMMARY_PDF_DOWNLOAD]: '/reviewSummarydownload/ssap/sendSummaryToInbox?caseNumber=${caseNumber}',

    [LCE_REFERRAL]: '/referral/lce/events/applicants/${encryptedCaseNumber}',
    [LCE_CLONE]: '/referral/lce/events/clone/usersystemerror/${encryptedCaseNumber}',
    [VERIFY_ACCESS_CODE]: '/referral/checkaccesscode?accessCode=${accessCode}',
    [ACCOUNT_ACCESS_CODE]: '/referral/verifyaccesscode',
    [ACCOUNT_LOGIN]: '/account/user/login',
    [ACCOUNT_SIGNUP]: '/account/user/ssnDetails',
    [ACCESS_CODE_REDIRECT]: '/${redirectUrl}',

    [CHANGE_LANGUAGE]: '/private/changeLang?lang=${language}',
    [COUNTRIES_ENDPOINT]: '/hub/getCountryOfIssuanceList',
    [DASHBOARD_ENDPOINT]: '/account/user/getDashBoard',
    [REPORT_A_CHANGE]: '/iex/lce/reportyourchange?coverageYear=${applicationYear}',
    [RIDP_CURRENT_USER_INFO_ENDPOINT]: '/ridp/currentUserInfo?ts=${ts}&viewRef=${viewRef}',
    [RIDP_VIEWREF_ENDPOINT]: '/ridp/verification',
    [RIDP_VALIDATE_PRIMARY_ENDPOINT]: '/ridp/validateRIDPPrimary',
    [RIDP_VALIDATE_SECONDARY_ENDPOINT]: '/ridp/validateRIDPSecondary',
    [RIDP_MANUAL_VERIFICATION_ENDPOINT]: '/ridp/manualVerificationFileUpload?viewRef=${viewRef}',
    [RIDP_VALIDATE_FARS_ENDPOINT]: '/ridp/validateFARS',
    [RIDP_CLEAR_DHS_ENDPOINT]: '/ridp/clearDHSReferenceNumber',
    [VALIDATE_ADDRESS_ENDPOINT]: '/address/validate',
    [IDA_LINK]: '/individual/saml/idalinkredirect',
    [HTML_2_PDF_SCRIPT_ENDPOINT]: '/resources/spa/scripts/html2pdf.bundle.js',
    [INBOX_HOME]: '/inbox/home',
    [DELEGATION_HISTORY]: '/designation/history?pageNumber=${pageNumber}',
    [EDE_ID_PROOFING_ENDPOINT]: '/broker/identity-proofing-records',
    [EDE_SEARCH_ENDPOINT]: '/broker/searchConsumer',
    [EDE_SEARCH_ADD_TO_BOB]: '/broker/selfdelegation',
    [EDE_ADD_CONSUMER]: '/cap/consumer/addconsumer?identityProofing=${identityProofId}',
    [EDE_BACK_TO_ACTIVE_INDIVIDUALS]: '/book-of-business/agent',
    [EDE_BACK_TO_DASHBOARD]: '/broker/dashboard',
    [ADD_CONSUMER]: '/cap/consumer/addconsumer?callID=${callInteractionID}',
    [ADD_CONSUMER_WITHOUT_CALL_ID]: '/cap/consumer/addconsumer',
    [VIEW_MEMBER]: '/crm/member/viewmember/${encryptedHouseholdId}',
    [NAV_BAR]: '/account/user/menu',
    [HEADER_ROLES_LINK]: '/account/user/switchUserRole/${encryptedRoleName}?assigned=true',
    [AGENT_LEFT_NAV_PARAMS]: '/dashboard/leftNav',
    [BACK_TO_DASHBOARD]: '/broker/dashboard',
    [BROKER_EMP]: '/broker/employers?desigStatus=Pending',
    [BROKER_IND]: '/broker/individuals?desigStatus=Pending',
    [BROKER_NEW_EMP]:
        '/broker/employer/dashboard?switchToModuleName=Employer&switchToModuleId=-1&switchToResourceName=SettingUpNewEmployer',
    [BROKER_VIEW_PROFILE]: '/broker/viewprofile',
    [BROKER_VIEW_PENDING_INDIVIDUAL]: '/broker/individuals?desigStatus=Pending',
    [BROKER_ADD_NEW_INDIVIDUAL]: '/cap/consumer/addconsumer',
    [BROKER_TICKET]: '/bp/ticket',
    [ASSISTER_VIEW_PROFILE]: '/entity/assister/viewassisterprofilebyuserid',
    [ASSISTER_IND]: '/entity/assister/individuals?desigStatus=Pending',
    [UNREAD_MESSAGE_COUNT]: '/inbox/secureInboxUnread', // future change here for red dot notifier
    [LOGOUT_URL]: '/account/user/logout',

    [BROKERCONNECT_DATA]: '/api/broker/connect/data',
    [BROKERCONNECT_PARTICIPATION_DETAILS]: '/api/broker/connect/participation-details',
    [BROKERCONNECT_HOURS]: '/api/broker/connect/hours',
    [BROKERCONNECT_AVAILABILITY]: '/api/broker/connect/available',

    [START_SHOPPING]: '/preeligibility',
    [J_SECURITY_CHECK]: '/j_spring_security_check',
    [AUTHENTICATION_SUCCESS_REDIRECT]: '/${redirectUrl}',
    [IMAGES]: '${relativePath}/${fileName}',

    [NEW_INBOX_HOME]: '/inbox',
    [NOTIFICATIONS]: '/inbox/messages?${part}=${id}&encrypted=${isEncrypted}&pageNumber=${pageNumber}',
    [MEMBER_ACCOUNT_ACTIVITY_DETAILS]: '/crm/consumer/searchAppEvents',
    [MEMBER_ACCOUNT_ACTIVITY_EVENT_COMMENTS]: '/crm/member/appeventcomments',
    [MEMBER_ACCOUNT_ACTIVITY_LOG_CALL]: '/cap/history/calllog',
    [MEMBER_ACCOUNT_ACTIVITY_ADD_CALL_NOTE]: '/crm/member/addCallNotes/${eventId}',
    [MEMBER_ACCOUNT_ACTIVITY_ADD_CHAT_NOTE]: '/crm/member/addChatNotes/${eventId}',
    [MEMBER_ACCOUNT_ACTIVITY_EXPORT_HISTORY]: '/exportHistory/${encHouseholdId}',
    [MEMBER_ACCOUNT_ACTIVITY_INIT_CALL]: '/crm/consumer/viewHistory/filters/${encHouseholdId}',
    [EMAIL_PDF_PREVIEW]:
        '/inbox/viewraw?fileName=${pdfFileKey}&read=${read}&enlarged=${isEnlarged}&language=${language}',
    [EMAIL_PDF_PREVIEW_WITH_IMPERSONATION]:
        '/inbox/viewraw?fileName=${pdfFileKey}&read=${read}&enlarged=${isEnlarged}&language=${language}&householdId=${householdId}',
    [ENLARGED_FONT_ENABLED]: '/inbox/environment',
    [GET_UNREAD_NOTIFICATION_COUNT]: '/inbox/count?${part}=${id}&encrypted=${isEncrypted}',

    [GET_IVR_DATA]: '/crm/member/referenceData/${refId}',
    [SCREENPOP_ASSISTER_DATA]: '/entity/assisteradmin/manageassister/cap/list',
    [SCREENPOP_BROKER_DATA]: '/admin/broker/manage/cap/list',
    [GET_SCREENPOP_COUNTIES]: '/entity/entityadmin/cap/counties',
    [LOG_CALL_DATA]: '/cap/logcalldata',
    [SEARCH_APPLICANT]: '/ghix-eligibility/eligibility/searchApplicant',

    [VIEW_MEMBER_ACCOUNT]: 'crm/consumer/dashboard',

    [SECURE_INBOX_SEND]: '/inbox/secureInboxSend',
    [SEARCH_CEC]: '/entity/searchAssistersWithPagination?pageNumber=${pageNumber}',
    [CEC_EXPORT_BOB]: '/entity/bookofbusiness/export/${assisterId}',
    [CEC_EXPORT_BOB_NON_CA]: '/entity/entityadmin/exportcsv/${assisterId}',
    [ENTITY_SITE_LIST]: '/entity/site/list',
    [FILTER_CEC_ENTITYADMIN]: '/entity/entityadmin/searchAssistersWithPagination?pageNumber=${pageNumber}',
    [REASSIGN_BOB_TO_CEC]: '/entity/entityadmin/reassignBOBToCEC',
    [ENTITY_ASSISTERS_LIST]: '/entity/entityadmin/displayassisters?showCECLeftnavigation=true',
    [ACK_TRNFR_STATUS]: '/agency/acknowledge',
    [GET_TRNFR_STATUS]: '/agency/transferstatus',

    [ANNOUNCEMENTS]: '/indportal/announcements',

    [EXTERNAL_CONTENT]: '/getExternalContent?pageName=${pageName}',

    // GAEP
    [AGENT_LIST]: '/gaep/ins-company',
    [GA_CARRIER_GAEP_LIST]: '/partner/list?isCarrierFlag=${flag}',
    [ZIPCODE_COUNTIES]: '/iex/getCountyByZip?zip=${value}',
    [PARTNER_BROKER]: '/designated/enroller/profile/${encryptedHouseholdId}',

    // GA CARRIERS
    [PARTNER_LIST]: '/partner/list?isCarrierFlag={isCarrierFlag}&zipCode={zipCode}',
    [VALIDATE_ZIP]: '/iex/validateZip',

    // AGENTS
    [AGENTS_SEARCH_BY_NAME]:
        '/broker/list/name?pageNumber={pageNumber}&firstName={firstName}&lastName={lastName}&businessName={companyName}',
    [AGENTS_SEARCH_BY_ZIP]:
        '/broker/list/zip?pageNumber={pageNumber}&zipCode={zipcode}&distance={distance}&languagesSpoken={languagesSpoken}',

    // ARCHIVE HH
    [ARCHIVE_HH_ARCHIVE]: '/household/archivehousehold/archive',
    [ARCHIVE_HH_SEARCH]: '/household/archivehousehold/search/{hhid}',
    [ARCHIVE_HH_UNARCHIVE]: '/household/archivehousehold/unarchive',

    // SSIO
    [SSIO_EXECUTE_STEP]: '/ssio/executestep',
    [SSIO_TEST_PLAN_RESULTS]: '/ssio/testplanresults',
    [SSIO_TEST_PLAN_DETAILS]: '/ssio/testplandetails',
    [SSIO_RESTART_STEP]: '/ssio/restart',
    [ARCHIVE_HH_UNARCHIVE]: '/household/archivehousehold/unarchive',

    //INVOICE MANAGEMENT
    [IVM_DOWNLOAD_DOCUMENT]: '/ivm/downloadDocument',
    [IVM_CONFIRMATION]: '/ivm/confirmation',
    [IVM_ENVIRONMENT]: '/ivm/environment',
    [IVM_ISSUER_LIST]: '/ivm/issuerList',
    [IVM_PREVIEW_PACKET]: '/ivm/previewPacket/{packetId}',
    [IVM_PREVIEW_STATEMENT]: '/ivm/previewStatement/{statementId}',
    [IVM_RESEND_PACKETS]: '/ivm/resendPacket',
    [IVM_REVIEW_PACKET]: '/ivm/reviewPacket/{packetId}',
    [IVM_SEND_PACKET]: '/ivm/sendPacket',
    [IVM_STATEMENT_PACKETS]: '/ivm/statementPackets/{year}/{encryptedIssuerHIOSId}',
    [IVM_UPDATE_EMAIL_PHONE]: '/ivm/updateEmailPhone',
    [IVM_UPDATE_COMMENTS]: '/ivm/updateCommentForStatement',
    [FETCH_HOUSHOLDS_ELIGIBILITY]:
        '/ghix-eligibility-engine/eligibilityEngine/formulationdetails/{householdId}/{coverageyear}',
    [WORKGROUP_BY_STATUS]: '/hix/ticketmgmt/ticket/getDueDateReports',
    [WORKGROUP_BY_DUEDATE]: '/hix/ticketmgmt/ticket/getOpenTicketReports',
    [WORKGROUP_BY_USER]: '/hix/ticketmgmt/ticket/getDueDateReports',
    [FETCH_HOUSHOLDS_ELIGIBILITY]: '/hix/ssap/formulationdetails/{caseNumber}',
    [RESOLVED_DATE_REPORTS_BY_WORKGROUP]: '/hix/ticketmgmt/ticket/getResolvedDateReportsByWorkGroup',
    [RESOLVED_DATE_REPORTS_BY_WORKGROUP_ASSIGNEE]: '/hix/ticketmgmt/ticket/getResolvedDateReportsGroupByAssignee',
    [RESOLVED_DATE_REPORTS_BY_WORKGROUP_ASSIGNEE_DRILL_DOWN]:
        '/hix/ticketmgmt/ticket/getResolvedDateReportsByWorkGroupAssignee',
    [RESOLVED_DATE_REPORTS_GROUP_BY_ASSIGNEE_FOR_ASSIGNEEID_DRILL_DOWN]:
        '/hix/ticketmgmt/ticket/getResolvedDateReportsGroupByAssigneeForAssigneeId',

    // Enrollment History
    [PAY_FOR_HEALTH]: '/indportal/payforhealth',
    [CHANGE_TERMINATION_DATE]: '/indportal/enrollments/terminationDate',

    //TICKET FILE
    [GET_ATTACHMENTS_URL]: '/ticketmgmt/ticket/getAttachments',
    [POST_ATTACHMENTS_URL]: '/ticketmgmt/ticket/consumer/uploadAttachments',
    [DELETE_ATTACHMENT_URL]: '/ticketmgmt/ticket/softDeleteAttachments',
    [VIEW_ATTACHMENT_URL]: '/ticketmgmt/ticket/viewConsumerDocument?documentId=',

    //Custom Grouping
    [CUSTOM_GROUPING_DETAIL]: '/indportal/customGrouping?caseNumber=${caseNumber}',
    [CHECK_FOR_PENDING_APPLICATION]: '/indportal/checkForPendingApplication',
    [TERMINATE_HEALTH_PLAN]: '/indportal/terminateHealthPlan',
    [TERMINATE_DENTAL_PLAN]: '/indportal/terminateDentalPlan',
    [PLAN_SHOPPING]: '/private/setHousehold/${shoppingId}',

    // Enrollment History Management
    [GET_ENROLLMENT_HISTORY]: '/indportal/enrollmenthistory?coverageYear=${coverageYear}&tmstp=${timestamp}',
    [CHECK_FOR_PENDING_APPLICATION]: '/indportal/checkForPendingApplication',
    [DISENROLL_MEMBERS]: '/indportal/disenrollMembers',
    [SAVE_CUSTOM_GROUPING]: '/indportal/saveCustomGrouping?caseNumber=${caseNumber}',
    [TERMINATE_DENTAL_PLAN]: '/indportal/terminateDentalPlan',
    [TERMINATE_HEALTH_PLAN]: '/indportal/terminateHealthPlan',
    [TERMINATE_PLAN]: '/indportal/terminatePlan',
    [GET_ATTACHMENTS_URL]: '/ticketmgmt/ticket/getAttachments',
    [POST_ATTACHMENTS_URL]: '/ticketmgmt/ticket/consumer/uploadAttachments',
    [DELETE_ATTACHMENT_URL]: '/ticketmgmt/ticket/softDeleteAttachments',
    [VIEW_ATTACHMENT_URL]: '/ticketmgmt/ticket/viewConsumerDocument?documentId=',

    //Member
    [VIEW_ATTACHMENT_URL]: '/ticketmgmt/ticket/viewConsumerDocument?documentId=',
    [ADD_MEMBER]: '/cap/consumer/addconsumersubmit',
    [GET_SSN_DETAILS]: '/cap/consumer/ssndetails',
    [MEMBER_ENROLLMENT_LIST_DETAILS]: '/crm/member/enrollmentdetails',
    [MEMBER_ENROLLMENT_LIST_ENROLLEE_DETAILS]: '/crm/member/enrollmentandenrolleedetails',
    [MEMBER_ENROLLMENT_LIST_PERMISSIONS]: '/crm/member/enrollmentinfo/${id}',
    [MEMBER_ENROLLMENT_DETAILS]: '/cap/member/enrollment/premiumhistorydetails?encEnrollmentId=${id}',

    //CAP Gb
    [MEMBER_APP_LIST_CONTROLLER]: '/crm/applications/${encHouseHoldId}',
    [MEMBER_APP_LIST_OUTBOUND_BUTTON_STATUS]: '/cap/getOutBoundButtonStatus?caseNumber=${caseNumber}',
    [MEMBER_APP_LIST_GET_APPS]:
        '/crm/getApplications?coverageYear=${coverageYear}&tmstp=${newDateTime}&encHouseholdId=${encHouseholdId}',
    [MEMBER_APP_LIST_OVERRIDE_COMMENT]: '/indportal/addOverrideComment?encHouseholdid=${encHouseHoldId}',
    [MEMBER_APP_LIST_INIT_VERIFICATIONS]: '/indportal/initVerifications?caseNumber=${caseNumber}',
    [MEMBER_APP_LIST_RERUN_ELIGIBILITY]: '/indportal/rerunEligibility?caseNumber=${caseNumber}',
    [MEMBER_APP_LIST_TERMINATE_PLAN]: '/indportal/terminatePlan',
    [MEMBER_APP_LIST_REVERSE_DENIAL]: '/indportal/seps/reversedenial',
    [MEMBER_APP_LIST_UPDATE_CARRIER]: '/indportal/updateCarrier?caseNumber=${caseNumber}',
    [MEMBER_APP_LIST_SAVE_SEP_DETAILS]: '/indportal/saveSepDetails',
    [MEMBER_APP_LIST_SAVE_SEP_OVERRIDE_DETAILS]: '/indportal/overrideSEPDetails?&encHouseholdid=${encHouseHoldId}',
    [MEMBER_APP_LIST_SEND_OBAT]: '/cap/sendobat?caseNumber=${caseNumber}',
    [MEMBER_APP_LIST_UPDATE_ENROLLMENT_STATUS]: '/indportal/updateEnrollmentStatus',
    [MEMBER_APP_LIST_CHECK_ACTIVE]: '/indportal/applications/${appCoverageDate}/checkactive',
    [MEMBER_APP_LIST_PROGRAM_ELIGIBILITY]: '/cap/getProgrmeEligibility?caseNumber=${caseNumber}',
    [MEMBER_APP_LIST_OVERRIDE_PROGRAM_ELIGIBILITY]:
        '/cap/overrideProgramElig?caseNumber=${caseNumber}&coverageYear=${coverageYear}',
    [MEMBER_APP_LIST_ADD_OVERRIDE_COMMENT]: '/indportal/addOverrideComment?encHouseholdid=${encHouseholdId}',
    [MEMBER_APP_LIST_SEP_EVENT_DETAILS]: '/cap/applicant/events/${caseNumber}/all/${encHouseHoldId}',
    [MEMBER_APP_LIST_GET_SEP_DETAILS]: '/indportal/getSepDetails?caseNumber=${caseNumber}',
    [MEMBER_APP_LIST_OVERRIDE_APPLICATION_LOCK]: '/cap/overrideApplicationLock',
    [MEMBER_APP_LIST_OVERRIDE_APPLICATION_END_SEP]: '/cap/overrideapplicationendsep',
    [MEMBER_APP_LIST_GET_ELIGIBILITY_DATE_DETAILS]:
        '/cap/getEligibilityDateDetails?caseNumber=${caseNumber}&coverageYear=${coverageYear}&encHouseholdid=${encHouseHoldId}',
    [MEMBER_APP_LIST_GET_SEP_PERIOD_DATES]: '/indportal/getSEPPeriodDates?caseNumber=${caseNumber}',
    [MEMBER_APP_LIST_GET_SEP_EVENTS_BY_APPLICATION_TYPE]: '/indportal/getSEPEventsByApplicationType',
    [MEMBER_APP_LIST_GET_QHP_APPLICANTS]: '/indportal/getQHPApplicants/${caseNumber}',
    [MEMBER_APP_LIST_SAVE_SHOPPING_WINDOW]: '/indportal/saveShoppingWindow?encHouseholdid=${encHouseHoldId}',
    [MEMBER_APP_LIST_NEW_SSAP_START]:
        '/account/user/switchUserRole?switchToModuleName=${switchToModuleName}&switchToModuleId=${switchToModuleId}&switchToResourceName=${switchToResourceName}&switchToNonDefaultURL=/indportal/editapplication?caseNumber=${caseNumber}',
    [MEMBER_APP_LIST_APPLICATIONS]: '/cap/member/applications/${encHouseHoldId}',
    [MEMBER_APP_LIST_CLONE_APPLICATION_BY_CASENUMBER]: '/indportal/cloneApplicationByCaseNumber/${caseNumber}',

    [MEMBER_ENROLLMENT_LIST_ENROLLMENT_UPDATE_ENROLLMENT]: '/crm/member/updateEnrollmentdetails',
    [MEMBER_ENROLLMENT_LIST_ENROLLMENT_DETAIL_SNAPSHOT]:
        '/crm/member/enrollmentsnapshot?enrollmentId=${enrollmentId}&subscriberEventId=${subscriberEventId}',
    [MEMBER_ENROLLMENT_LIST_ENROLLMENT_RESEND_COMMENT]:
        '/crm/member/resend834?encEnrollmentId=${encEnrollmentId}&eventType=${eventType}&comment=${comment}',
    [MEMBER_ENROLLMENT_LIST_ENROLLMENT_UPDATE_STATUS]: '/crm/updateEnrollmentStatus',
    [MEMBER_ENROLLMENT_LIST_ENROLLMENT_REINSTATE_STATUS]: '/crm/reinstateenrollment',
    [MEMBER_ENROLLMENT_LIST_ENROLLMENT_CANCEL_ACTIVE]: '/crm/member/cancelenrollment',

    [MEMBER_ENROLLMENT_LIST_ENVIRONMENT_CANCEL_PREMIUM_HISTORY]: '/enrollment/update/status',

    // Dmi
    [DMI_GET_DMI_VERIFICATIONS]: '/v1/verificationResultDashboard?caseNumber=${caseNumber}&lang=${language}',
    [DMI_VLP_VERIFICATIONS]: '/cap/vlp/verifications',
    [DMI_GET_HOUSEHOLD_INCOME]: '/ssap/householdComposition/${applicationid}',
    [DMI_DELETE_UPLOADED_DOCUMENT_ENDPOINT]: '/ssap/deleteDocument?documentId=${documentId}',
    [DMI_OVERRIDE_DOCUMENTS]: '/ssap/verifyApplicantDocCategory',
    [DMI_LOAD_DOCUMENT_ENDPOINT]: '/documents/load',
    [DMI_UPLOAD_DOCUMENT_ENDPOINT]: '/ssapdocumentmgmt/documents/uploadDmiDocumentAttachmentsAjax',
    [DMI_UPLOAD_DOCUMENT_QR_CODE_ENDPOINT]: '/documents/qr-codes/generate',
    [DMI_VIEW_UPLOADED_DOCUMENT_ENDPOINT]: '/indportal/viewDocument?documentId=',
    [DMI_VIEW_TICKET_ENDPOINT]: '/indportal/switchCSRToTicket/',
};

const hostNames = {
    default: window.location.origin,
    host1: 'http://localhost:8089',
    host2: 'http://localhost:8081',
};

const prefixes = {
    default: '/hix',
    prefix1: '/ssap',
    prefix2: '/web',
    prefix3: '',
};

const isCustom = mode === environments.CUSTOM;

const endpointsConfig = [
    {
        hostName: window.location.origin,
        customHostName: 'host1',
        prefix: '/hix',
        customPrefix: 'prefix1',
        endpoints: [
            ACCESS_CODE_REDIRECT,
            ACCOUNT_ACCESS_CODE,
            ACCOUNT_LOGIN,
            ACCOUNT_SIGNUP,
            ADD_CONSUMER,
            ADD_CONSUMER_WITHOUT_CALL_ID,
            ADD_MEMBER,
            AGENT_LEFT_NAV_PARAMS,
            AGENT_LIST,
            AGENTS_SEARCH_BY_NAME,
            AGENTS_SEARCH_BY_ZIP,
            ANNOUNCEMENTS,
            APPLICATIONS,
            APPLICATIONS_NEW,
            ARCHIVE_HH_ARCHIVE,
            ARCHIVE_HH_SEARCH,
            SSIO_EXECUTE_STEP,
            SSIO_TEST_PLAN_RESULTS,
            SSIO_TEST_PLAN_DETAILS,
            SSIO_RESTART_STEP,
            ARCHIVE_HH_UNARCHIVE,
            ASSISTER_VIEW_PROFILE,
            ASSISTER_IND,
            AUTHENTICATION_SUCCESS_REDIRECT,
            BACK_TO_DASHBOARD,
            BLOOD_RELATIONSHIPS_CHECK,
            BLOOD_RELATIONSHIPS_ENDPOINT,
            BLOOD_RELATIONSHIPS_ENDPOINT_WHOLE_LIST,
            BROKER_ADD_NEW_INDIVIDUAL,
            BROKER_EMP,
            BROKER_IND,
            BROKER_NEW_EMP,
            BROKER_TICKET,
            BROKER_VIEW_PENDING_INDIVIDUAL,
            BROKER_VIEW_PROFILE,
            BROKERCONNECT_DATA,
            BROKERCONNECT_PARTICIPATION_DETAILS,
            BROKERCONNECT_HOURS,
            BROKERCONNECT_AVAILABILITY,
            CANCEL_APP,
            CHECK_ACTIVE_ENROLLMENT,
            CHECK_FOR_PENDING_APPLICATION,
            [COPY_APP_BY_CASE_NUMBER],
            CLONE_APP_BY_CASE_NUMBER,
            CLONE_APP_BY_SSAP_ID,
            CHANGE_LANGUAGE,
            CHANGE_APP_STATUS,
            COMMENTS,
            COMMUNICATION_PREFERENCES,
            OTP_VERIFY,
            OTP_SEND,
            PARTIAL_UPDATE,
            COUNTIES_FOR_STATE_ENDPOINT,
            COUNTIES_FOR_STATES_ENDPOINT,
            COUNTY_ENDPOINT,
            COUNTRIES_ENDPOINT,
            CUSTOM_GROUPING,
            CUSTOM_GROUPING_DETAIL,
            DASHBOARD_ENDPOINT,
            DASHBOARD_MODELS,
            DASHBOARD_MODELS_LITE,
            DELEGATION_HISTORY,
            DISENROLL_MEMBERS,
            DMI_GET_DMI_VERIFICATIONS,
            DMI_VLP_VERIFICATIONS,
            DMI_GET_HOUSEHOLD_INCOME,
            DMI_DELETE_UPLOADED_DOCUMENT_ENDPOINT,
            DMI_OVERRIDE_DOCUMENTS,
            DMI_LOAD_DOCUMENT_ENDPOINT,
            DMI_UPLOAD_DOCUMENT_ENDPOINT,
            DMI_UPLOAD_DOCUMENT_QR_CODE_ENDPOINT,
            DMI_VIEW_UPLOADED_DOCUMENT_ENDPOINT,
            DMI_VIEW_TICKET_ENDPOINT,
            DOCUMENTS_VERIFICATION_DATA,
            DOCUMENTS_VERIFICATION_ENDPOINT,
            EDE_ID_PROOFING_ENDPOINT,
            EDE_SEARCH_ENDPOINT,
            EDE_SEARCH_ADD_TO_BOB,
            EDE_ADD_CONSUMER,
            EDE_BACK_TO_DASHBOARD,
            ELIGIBILITY_RESULTS,
            ELIGIBILITY_RESULTS_NEW,
            EMAIL_PDF_PREVIEW,
            EMAIL_PDF_PREVIEW_WITH_IMPERSONATION,
            ENLARGED_FONT_ENABLED,
            MEMBER_ENROLLMENT_LIST_DETAILS,
            MEMBER_ENROLLMENT_LIST_ENROLLEE_DETAILS,
            MEMBER_ENROLLMENT_DETAILS,
            MEMBER_ENROLLMENT_LIST_PERMISSIONS,
            MEMBER_ENROLLMENT_LIST_ENROLLMENT_DETAIL_SNAPSHOT,
            MEMBER_ENROLLMENT_LIST_ENROLLMENT_RESEND_COMMENT,
            MEMBER_ENROLLMENT_LIST_ENROLLMENT_REINSTATE_STATUS,
            MEMBER_ENROLLMENT_LIST_ENROLLMENT_UPDATE_STATUS,
            MEMBER_ENROLLMENT_LIST_ENROLLMENT_CANCEL_ACTIVE,
            MEMBER_ENROLLMENT_LIST_ENROLLMENT_UPDATE_ENROLLMENT,
            MEMBER_ENROLLMENT_LIST_ENVIRONMENT_CANCEL_PREMIUM_HISTORY,
            ENVIRONMENT_VARIABLES,
            EXTERNAL_CONTENT,
            FLOW_ENDPOINT,
            TOBACCO_EXEMPT_GET_APPLICANTS,
            TOBACCO_EXEMPT_SAVE_ADDINFO,
            GET_SSN_DETAILS,
            GA_CARRIER_GAEP_LIST,
            GET_EXISTING_APP_ID,
            GET_ENROLLMENT_HISTORY,
            GET_IVR_DATA,
            SCREENPOP_BROKER_DATA,
            SCREENPOP_ASSISTER_DATA,
            GET_SCREENPOP_COUNTIES,
            GET_UNREAD_NOTIFICATION_COUNT,
            HEADER_ROLES_LINK,
            HTML_2_PDF_SCRIPT_ENDPOINT,
            IDA_LINK,
            IMAGES,
            INBOX_HOME,
            INDPORTAL_ERROR,
            INITIAL_DATA_ENDPOINT,
            J_SECURITY_CHECK,
            LOG_CALL_DATA,
            LOGOUT_URL,
            LCE_REFERRAL,
            LCE_CLONE,
            MEMBER_AFFORDABILITY,
            MEMBER_ACCOUNT_ACTIVITY_DETAILS,
            MEMBER_ACCOUNT_ACTIVITY_EVENT_COMMENTS,
            MEMBER_ACCOUNT_ACTIVITY_LOG_CALL,
            MEMBER_ACCOUNT_ACTIVITY_ADD_CALL_NOTE,
            MEMBER_ACCOUNT_ACTIVITY_ADD_CHAT_NOTE,
            MEMBER_ACCOUNT_ACTIVITY_EXPORT_HISTORY,
            MEMBER_ACCOUNT_ACTIVITY_INIT_CALL,
            MULTIHOUSEHOLD_DETAILS,
            NAV_BAR,
            NEW_INBOX_HOME,
            NOTIFICATIONS,
            OLD_START_SSAP_BY_CASE_NUMBER,
            OVERRIDE_DOCUMENTS,
            PAY_FOR_HEALTH,
            CHANGE_TERMINATION_DATE,
            PARTNER_LIST,
            PRE_OEP_LANDING,
            PRE_ELIGIBILITY,
            PRE_ELIGIBILITY_BROWSE_PLANS,
            PRE_ELIGIBILITY_BROWSE_PLANS_REDIRECT,
            PRE_ELIGIBILITY_CALCULATE_SAVINGS,
            PRE_ELIGIBILITY_DISCLAIMER,
            PRE_ELIGIBILITY_DISCLAIMER_FROM_HOME,
            PRE_ELIGIBILITY_DISCLAIMER_FROM_FLOW,
            PRE_ELIGIBILITY_DISCLAIMER_JSP,
            PRE_ELIGIBILITY_RESULTS,
            PRE_ELIGIBILITY_RESULTS_APTC_IMAGE,
            PRE_ELIGIBILITY_RESULTS_CSR_IMAGE,
            PRE_ELIGIBILITY_RESULTS_CHIP_IMAGE,
            PRE_ELIGIBILITY_RESULTS_INELIGIBLE_IMAGE,
            PRE_ELIGIBILITY_RESULTS_MEDICARE_IMAGE,
            PRE_ELIGIBILITY_RESULTS_MEDICAID_IMAGE,
            PRE_ELIGIBILITY_RESULTS_NA_IMAGE,
            PRE_ELIGIBILITY_RESULTS_STATE_SUBSIDY_IMAGE,
            PRE_ELIGIBILITY_RESULTS_ZERO_APTC_IMAGE,
            PRE_ELIGIBILITY_RESULTS_NAVIGATE_NEXT,
            PRE_ELIGIBILITY_SCREENING,
            POST_TICKET,
            PLAN_SHOPPING,
            PLAN_SUMMARY,
            QEP,
            REMOVE_UPLOADED_DOCUMENT,
            REPORT_A_CHANGE,
            REQUEST_FULL_DETERMINATION,
            REVIEW_SUMMARY_PDF_DOWNLOAD,
            RIDP_CURRENT_USER_INFO_ENDPOINT,
            RIDP_VIEWREF_ENDPOINT,
            RIDP_VALIDATE_PRIMARY_ENDPOINT,
            RIDP_VALIDATE_SECONDARY_ENDPOINT,
            RIDP_MANUAL_VERIFICATION_ENDPOINT,
            RIDP_VALIDATE_FARS_ENDPOINT,
            RIDP_CLEAR_DHS_ENDPOINT,
            SSAP_PRE_ELIGIBILITY,
            SAVE_DATA_ENDPOINT,
            SAVE_COMMENT,
            SAVE_CUSTOM_GROUPING,
            SAVE_TOBACCO,
            SAVE_SEEKS_QHP_CHANGES,
            SECURE_INBOX_SEND,
            SET_ACTIVE_HOUSEHOLD,
            SET_FULL_DETERMINATION,
            START_SHOPPING,
            START_SSAP_BY_CASE_NUMBER,
            START_SSAP_BY_YEAR,
            SUBMIT_DOCUMENTS,
            TERMINATE_DENTAL_PLAN,
            TERMINATE_HEALTH_PLAN,
            TERMINATE_PLAN,
            TICKET_MGMT_CATEGORIES,
            TICKET_MGMT_GET_TAGS,
            TICKET_MGMT_UPDATE_TAG,
            TICKET_MGMT_WORKGROUPS_TAGS,
            TICKET_MGMT_EXCHANGE_ASSIGNEES,
            TICKET_MGMT_UPDATE_ASSIGNEE_ATTRIBUTES,
            TICKET_MGMT_PERMISSIONS,
            TICKET_MGMT_UPDATE_CATEGORY,
            TICKET_MGMT_SAVE_NEW_TICKET_TYPE,
            TICKET_MGMT_GET_CONSUMER_DATA,
            TICKET_MGMT_WORKGROUPS,
            TICKET_MGMT_WORKFLOW_BY_CATEGORY,
            TICKET_MGMT_WORKFLOW_TYPES,
            TICKET_MGMT_REASSIGN_TICKET,
            TICKET_MGMT_GET_ACTIVE_TASKS,
            TICKET_MGMT_GET_ALL_USERS_FOR_QUEUE,
            TICKET_MGMT_CANCEL_TICKET,
            TICKET_DETAIL,
            TICKET_TYPES,
            TICKETS,
            TICKET_MGMT_CREATE_PAGE,
            TICKET_MGMT_LIST,
            TICKET_MGMT_DEFAULT_QUEUE,
            TICKET_MGMT_MANAGE_QUEUE,
            TICKET_MGMT_TICKET_DETAIL,
            TICKET_MGMT_TICKET_DETAIL_BACKDOOR,
            TICKET_MGMT_TICKET_HISTORY,
            TICKET_MGMT_TICKET_COMMENTS,
            TICKET_MGMT_TICKET_DOCUMENTS,
            TICKET_MGMT_TICKET_TASKLIST,
            TICKET_MGMT_TICKET_SEND_MESSAGE,
            TICKET_MGMT_GET_RECLASSIFIED_PROPERTIES,
            TICKET_MGMT_GET_FILE_UPLOAD_FLAG,
            TICKET_MGMT_GET_TICKET_TYPES,
            TICKET_MGMT_SUBMIT_RECLASSIFY,
            TICKET_MGMT_CANCEL_TICKET,
            TICKET_MGMT_REOPEN_TICKET,
            TICKET_MGMT_USER_TASKLIST,
            TICKET_MGMT_UPLOAD_ATTACHMENTS,
            TICKET_MGMT_SAVE_COMMENT,
            GET_CUSTOM_FIELDS_URL,
            GET_CUSTOM_FIELDS_FOR_DEV_ENVIRONMENT,
            GET_USER_SECURITY_DETAILS,
            RESET_PASSWORD,
            RESET_PASSWORD_ALTERNATE_EMAIL,
            UNLOCK_USER,
            TRIBES_ENDPOINT,
            UNREAD_MESSAGE_COUNT,
            UPLOAD_VERIFICATION_DOCUMENT,
            VALIDATE_ADDRESS_ENDPOINT,
            VALIDATE_ZIP,
            VERIFICATION_PENDING,
            VERIFICATION_RESULT_DASHBOARD,
            VERIFY_ACCESS_CODE,
            VIEW_MEMBER,
            VIEW_MEMBER_ACCOUNT,
            WRONG_ENDPOINT,
            SEARCH_CEC,
            CEC_EXPORT_BOB,
            CEC_EXPORT_BOB_NON_CA,
            ENTITY_SITE_LIST,
            FILTER_CEC_ENTITYADMIN,
            ENTITY_ASSISTERS_LIST,
            REASSIGN_BOB_TO_CEC,
            ACK_TRNFR_STATUS,
            GET_TRNFR_STATUS,
            ZIPCODE_COUNTIES,
            PARTNER_BROKER,
            WORKGROUP_BY_STATUS,
            WORKGROUP_BY_DUEDATE,
            WORKGROUP_BY_USER,
            GET_ATTACHMENTS_URL,
            POST_ATTACHMENTS_URL,
            DELETE_ATTACHMENT_URL,
            VIEW_ATTACHMENT_URL,
            RESOLVED_DATE_REPORTS_BY_WORKGROUP,
            RESOLVED_DATE_REPORTS_BY_WORKGROUP_ASSIGNEE,
            RESOLVED_DATE_REPORTS_BY_WORKGROUP_ASSIGNEE_DRILL_DOWN,
            RESOLVED_DATE_REPORTS_GROUP_BY_ASSIGNEE_FOR_ASSIGNEEID_DRILL_DOWN,
            UPLOADED_DOCUMENT_URL,
            MEMBER_APP_LIST_OUTBOUND_BUTTON_STATUS,
            MEMBER_APP_LIST_CONTROLLER,
            MEMBER_APP_LIST_GET_APPS,
            MEMBER_APP_LIST_OVERRIDE_COMMENT,
            MEMBER_APP_LIST_INIT_VERIFICATIONS,
            MEMBER_APP_LIST_RERUN_ELIGIBILITY,
            MEMBER_APP_LIST_TERMINATE_PLAN,
            MEMBER_APP_LIST_REVERSE_DENIAL,
            MEMBER_APP_LIST_UPDATE_CARRIER,
            MEMBER_APP_LIST_SAVE_SEP_DETAILS,
            MEMBER_APP_LIST_SAVE_SEP_OVERRIDE_DETAILS,
            MEMBER_APP_LIST_SEND_OBAT,
            MEMBER_APP_LIST_UPDATE_ENROLLMENT_STATUS,
            MEMBER_APP_LIST_OVERRIDE_APPLICATION_END_SEP,
            MEMBER_APP_LIST_CHECK_ACTIVE,
            MEMBER_APP_LIST_PROGRAM_ELIGIBILITY,
            MEMBER_APP_LIST_OVERRIDE_PROGRAM_ELIGIBILITY,
            MEMBER_APP_LIST_ADD_OVERRIDE_COMMENT,
            MEMBER_APP_LIST_SEP_EVENT_DETAILS,
            MEMBER_APP_LIST_GET_SEP_DETAILS,
            MEMBER_APP_LIST_OVERRIDE_APPLICATION_LOCK,
            MEMBER_APP_LIST_GET_ELIGIBILITY_DATE_DETAILS,
            MEMBER_APP_LIST_GET_SEP_PERIOD_DATES,
            MEMBER_APP_LIST_GET_SEP_EVENTS_BY_APPLICATION_TYPE,
            MEMBER_APP_LIST_GET_QHP_APPLICANTS,
            MEMBER_APP_LIST_SAVE_SHOPPING_WINDOW,
            MEMBER_APP_LIST_NEW_SSAP_START,
            MEMBER_APP_LIST_APPLICATIONS,
            MEMBER_APP_LIST_CLONE_APPLICATION_BY_CASENUMBER,
        ],
    },
    {
        hostName: window.location.origin,
        customHostName: 'host1',
        prefix: '',
        customPrefix: 'prefix1',
        endpoints: [EDE_BACK_TO_ACTIVE_INDIVIDUALS, TELEX_ENVIRONMENT],
    },
    {
        hostName: window.location.origin,
        customHostName: 'host1',
        prefix: '',
        customPrefix: 'prefix1',
        endpoints: [SEARCH_APPLICANT],
    },
    {
        hostName: window.location.origin,
        customHostName: 'host1',
        prefix: '',
        customPrefix: 'prefix3',
        endpoints: [
            ADDITIONAL_INFO,
            PRE_OEP_LANDING,
            IVM_DOWNLOAD_DOCUMENT,
            IVM_CONFIRMATION,
            IVM_ENVIRONMENT,
            IVM_ISSUER_LIST,
            IVM_PREVIEW_PACKET,
            IVM_PREVIEW_STATEMENT,
            IVM_RESEND_PACKETS,
            IVM_REVIEW_PACKET,
            IVM_SEND_PACKET,
            IVM_STATEMENT_PACKETS,
            IVM_UPDATE_EMAIL_PHONE,
            IVM_UPDATE_COMMENTS,
            FETCH_HOUSHOLDS_ELIGIBILITY,
            WORKGROUP_BY_STATUS,
            WORKGROUP_BY_DUEDATE,
            WORKGROUP_BY_USER,
            RESOLVED_DATE_REPORTS_BY_WORKGROUP,
            RESOLVED_DATE_REPORTS_BY_WORKGROUP_ASSIGNEE,
            RESOLVED_DATE_REPORTS_BY_WORKGROUP_ASSIGNEE_DRILL_DOWN,
            RESOLVED_DATE_REPORTS_GROUP_BY_ASSIGNEE_FOR_ASSIGNEEID_DRILL_DOWN,
        ],
    },
];

const productionEndpoints = urlTools.getEndpoints({
    endpointsConfig,
    endpointsValues,
    hostNames,
    prefixes,
    isCustom,
});

export const urlChunks = {
    HOUSEHOLD_ID: 'householdId',
    INBOX_SEARCH: '&subject=${subject}',
    USER_ID: 'userId',
};

export default {
    ...productionEndpoints,
    ...customEndpoints,
};
